// host page for the list of all Experimental Data
// fetch the information from the server

import React from 'react';
import datasetsList from '../dataStruct/datasetList.json';
import tubulin from '../images/tubulins.gif'
import challengeDataset from '../images/challenge2016.png'

class Datasets extends React.Component {
    constructor(props){
        super(props)
        this.state = {  dataExp:[],
                        dataExpFilt:[],
                        showChallenge2013:true,
                        showChallenge2016:true,
                        isLoading:false}
        this.fetchData = this.fetchData.bind(this);
        this.timeout=null;
        this.doDelayedUpdate.bind(this);
        this.filterList.bind(this);
    }
    componentDidMount(){
        this.fetchData()
    }

    doDelayedUpdate(str) {
        if( this.timeout) {
            clearTimeout(this.timeout); // nodejs function
        }
        
        this.timeout = setTimeout(() => this.filterList(str)
            , 500);
    }

    filterList(str){
        console.log(str);
        this.setState({dataExpFilt:this.state.dataExp.filter(d => {
            return JSON.stringify(d).includes(str);
            })
        })
        if (this.state.dataExpFilt.length === 0){
            this.state.showChallenge2013 = false;
            this.state.showChallenge2016 = false;
        }else {
            this.state.showChallenge2013 = true;
            this.state.showChallenge2016 = true;
        }
    }

    renderElement(cardName,route, imgUrl) {
        return ( 
                <div key={cardName} style={{margin:"10px"}}>
                    <a className="card link-trapeze-horizontal" onClick={() => this.props.history.push(route)}>
                        <picture className="card-img-top" style={{maxHeight:"256px",maxWidth:"256px"}}>
                            <img src={imgUrl} className="img-fluid" title="" alt={imgUrl}/>
                        </picture>
                        <div className="card-body" style={{maxWidth:"256px"}}>
                            <h3 className="card-title">{cardName}</h3>
                        </div>
                    </a>
                </div>
        );
    }

      // fetch the list of jsons from server
    fetchData(){
        const data = new FormData();
        data.append('name','real');
        let resp = []
        this.setState({isLoading:true})
        fetch('/api/getDatasets',
        {
            method: 'post',
            headers: {"Accept": "application/text"},
            mode: 'same-origin',
            body: data
        }).then (response => {
            this.setState({isLoading:false})

            if (response.ok) {
                response.json().then((r) => {
                    this.setState({ dataExp:r,
                                    dataExpFilt:r})
                })
            }
        })
    }

    render(){
        return (
            <div>
                <div style={{marginLeft:"auto",margin: "5px"}}>
                    <input type="text" placeholder="Search..." id="searchText"
                    onChange={() => this.doDelayedUpdate(document.getElementById("searchText").value)}/>
                </div>
                <hr></hr>
                <div style={{display:"flex",flexWrap:"wrap"}}>
                    {this.state.showChallenge2013 && this.renderElement('Challenge 2016','/Challenge/ChallengeSimulatedData',challengeDataset)}
                    {this.state.showChallenge2016 && this.renderElement('Challenge 2013','/Challenge/Challenge2013?path=data',tubulin)}
                    {this.state.isLoading ? 
                        <div style={{display:"flex", justifyContent:"center",margin:"140px"}}>
                            <span className="loader" role="status" style={{width:"40px", height:"40px"}}>
                                <span className="sr-only">Loading...</span>
                            </span>
                        </div>
                    :
                        this.state.dataExpFilt.map(d => {
                            return (
                                this.renderElement(d.name,'/DatasetPage?name='+d.name,'./../datasets/'+d.subpath+d.thumbnail)
                            )
                        })
                    }
                </div>
            </div>
        )
    }

}

export default Datasets;
